import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import WirePayeesPage, { getDefaultData } from "components/pages/WirePayeesPage";
import Classes, { Payee } from "model";

/**
 * @name CaptureWirePayeesSaved
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Payees".
 */
export default function CaptureWirePayeesSaved(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const payee = Payee.init({
        id: Payee.nextID(),
        payeeType: "domestic",
        addressType: "Domestic",
        financialInstitutionNumberType: "aba",
        nickname: "John Adams",
        name: "John Adams",
        email: "jadams@sample.com",
        account: "123456789",
        confirmAccount: "123456789",
        addressType: "Domestic",
        addressLine1: "123 Main Street",
        city: "ALBANY",
        state: "georgia",
        zip: "54321",
        financialInstitutionName: "Demo National Bank",
        financialInstitutionNumber: "061219694",
        financialInstitutionAddressLine1: "4556 Cherry Lane",
        financialInstitutionCity: "Marietta",
        financialInstitutionState: "georgia",
        financialInstitutionZip: "54321"
    });

    const defaultData = getDefaultData();
    const payees = [ ...defaultData.payees, payee ];
    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "payees" ], payees)
    .submit();

    console.log(data)

    return <WirePayeesPage data={ data } />;
}